import React from "react";

const Frame77 = () => {
      return(
            <div className="title-group">
                  <div className="we-have-what-youre-looking-fo-parent">
                        <b className="about">Choose your plan</b>
                        <div className="lorem-ipsum-is6">{`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's `}</div>
                  </div>
                  <div className="radio">
                        <div className="monthly-wrapper">
                              <div className="about">monthly</div>
                        </div>
                        <div className="about">yearly</div>
                  </div>
            </div>
      );
};

export default Frame77;